import axios from 'axios'
import {
  ACATS_TRANSFER_DETAILS_API,
  WITH_CREDENTIALS_CONFIG,
} from './constants'
import { parseJSON } from './jsonParser'

export const getTransferDetails = (acatsControlNumber: string) => {
  // FEECM-17598: Use custom JSON parser to preserve acatsControlNumber precision
  return axios.get(
    ACATS_TRANSFER_DETAILS_API(acatsControlNumber),
    {
      ...WITH_CREDENTIALS_CONFIG,
      transformResponse: [parseJSON],
    }
  )
}
